export const EXPERIMENT_NAMES = Object.freeze({
  PILATES_CHALLENGE_AND_NUTRITION_YOGA_PRICE_INCREASE_AU: 'pilates-challenge-and-nutrition-yoga-price-increase-au',
  PILATES_CHALLENGE_MULTIPLE_PLAN_SELECTOR: 'pilates-challenge-multiple-plan-selector',
  YOGA_28_DAY_CHALLENGE_REVAMP: 'yoga-28-day-challenge-revamp',
  YOGA_28_DAY_CHALLENGE_REVAMP_V2: 'yoga-28-day-challenge-revamp-v2',
  PILATES_28_DAY_CHALLENGE_BMI_STEP: 'pilates-28-day-challenge-bmi-step',
  PILATES_28_DAY_CHALLENGE_CHECKOUT_RENEWAL_PRICING: 'pilates-28-day-challenge-checkout-renewal-pricing',
  PILATES_28_DAY_CHALLENGE_CHECKOUT_APPLE_PAY_BUTTON: 'pilates-28-day-challenge-checkout-apple-pay-button',
  SOMATIC_YOGA_REVAMPED_FUNNEL: 'somatic-yoga-revamped-funnel',
  PILATES_28_DAY_CHALLENGE_NEW_EMAIL_CONSENT_STEP: 'pilates-28-day-challenge-new-email-consent-step',
  PILATES_28_DAY_CHALLENGE_CHECKOUT_SMALL_PLAN_SELECTORS: 'pilates-28-day-challenge-checkout-small-plan-selectors',
  PILATES_28_DAY_CHALLENGE_LP_NEW_IMAGE: 'pilates-28-day-challenge-lp-new-image',
});
